import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const observer = new MutationObserver((mutations) => {
      const inputMutations = mutations.filter(
        (mutation) => 
          [...mutation.addedNodes].filter((node) => node.tagName === "INPUT").length > 0
          || [...mutation.removedNodes]?.filter((node) => node.tagName === "INPUT").length > 0
      )

      if(inputMutations.length > 0) {
        this.element.requestSubmit()
      }
    })

    observer.observe(this.element, { childList: true, subtree: true })
  }
}
